import 'pixi-sound';
import { injectable } from 'inversify';

enum Sounds {
  NOTIFICATION = 'notification',
  JACKPOT_WINNER = 'jackpot-winner'
}

interface ISoundService {
  play(sound: Sounds): void;
}

@injectable()
class SoundService implements ISoundService {

  constructor() {
    PIXI.sound.add({
      [Sounds.NOTIFICATION]: '/static/sounds/notification-bells.mp3',
      [Sounds.JACKPOT_WINNER]: '/static/sounds/notification-jackpot.mp3'
    });
  }

  public play(sound: Sounds) {
    if (PIXI.sound.exists(sound)) {
      PIXI.sound.play(sound);
    }
    else {
      console.log('Sound not found');
    }
  }
}

export { ISoundService, SoundService, Sounds };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/sound-service/sound-service.ts